import { registerJSONResolver } from '../registry/jsonResolvers';
import { registerJSONType } from '../io/json';
import { registerEasing } from '../animation/Easing';
var installedPlugins = new Set();
export function createPluginContext() {
    return {
        registerJSONType: registerJSONType,
        registerJSONResolver: registerJSONResolver,
        registerEasing: registerEasing,
    };
}
export function installPlugin(plugin, LightDraw) {
    if (installedPlugins.has(plugin.name))
        return;
    installedPlugins.add(plugin.name);
    plugin.install(LightDraw);
}
export function getInstalledPlugins() {
    return Array.from(installedPlugins);
}
/** Test hook — reset installed plugin set. */
export function clearInstalledPlugins() {
    installedPlugins.clear();
}
